<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
<!--            <v-flex xs12>-->
<!--                <h3>Начисления</h3>-->
<!--            </v-flex>-->
            <v-flex xs12 sm6>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-data-table
                        :items="list.results"
                        :server-items-length="list.last_page"
                        :loading="listLoading.includes('fetchListFiles')"
                        hide-default-footer
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1">
                    <template v-slot:header>
                        <tr>
                            <th>Код</th>
                            <th>Тип запроса</th>
                            <th>Состояние</th>
                            <th>Статус квитирования с платежами</th>
                            <th class="justify-center mx-0">
                                <v-btn
                                        icon
                                        class="mr-2"
                                        @click="editItem(defaultCard)"
                                >
                                    <v-icon>mdi-pencil-plus</v-icon>
                                </v-btn>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.id }}</td>
                            <td>{{ item.kind }}</td>
                            <td>
                                {{ getChargeCondition(item.status).condition }}
                            </td>
                            <td>
                                {{ getAcknowledgmentStatus(item.billStatus).name }}
                            </td>
                            <td class="justify-center mx-0">
                                <v-btn
                                        icon
                                        class="mr-2"
                                        @click="editItem(item)"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                    <template slot="no-data">
                        <v-btn color="primary" @click="initialize">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="list.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'listForcedAcknowledgement',
  props: {
    charge_id: Number
  },
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    list () {
      return this.$store.getters['gis_gmpForcedAcknowledgement/list']
    },
    defaultCard () {
      return this.$store.getters['gis_gmpForcedAcknowledgement/defaultCard']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize (newSearch = false) {
      this.$store.dispatch('gis_gmpForcedAcknowledgement/fetchForcedAcknowledgementList', {
        charge: this.charge_id,
        pageId: (newSearch) ? 1 : this.pagination.page,
        search: this.search
      }).then(() => {
        if (newSearch) {
          this.pagination.page = 1
        }
      })
    },
    editItem (item) {
      if (item.id === 'new') {
        this.$store.commit('gis_gmpForcedAcknowledgement/createCard', Number(this.charge_id))
      } else {
        this.$store.dispatch('gis_gmpForcedAcknowledgement/fetchForcedAcknowledgementCard', item)
      }
      this.$router.push({ name: 'gis_gmp_forced_acknowledgement_card', params: { 'charge_id': this.charge_id, id: item.id } })
    },
    getChargeCondition (conditionId) {
      return this.$store.getters['gis_gmpCharge/getChargeCondition'](conditionId)
    },
    getAcknowledgmentStatus (id) {
      return this.$store.getters['gis_gmpCharge/getAcknowledgmentStatus'](id)
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
